(() => {
  if (window.skCj270Bound) return;
  window.skCj270Bound = true;
  let trigger;
  function updateCost(calculator) {
    const fields = ['build', 'support', 'build-unit', 'support-unit'].map(name => calculator.querySelector(`[data-cj-${name}]`));
    if (fields.some(field => !field)) return;
    const values = fields.map(field => field.value.trim() === '' ? NaN : Number(field.value));
    const valid = values.every(value => Number.isFinite(value) && value >= 0 && value <= 100000);
    fields.forEach((field, i) => field.setAttribute('aria-invalid', String(!Number.isFinite(values[i]) || values[i] < 0 || values[i] > 100000)));
    calculator.querySelector('[data-cj-cost-status]').textContent = valid ? calculator.dataset.resultLabel : calculator.dataset.error;
    calculator.querySelector('[data-cj-cost-tax]').hidden = !valid;
    calculator.querySelector('[data-cj-cost-total]').textContent = valid ? `¥${(Math.round((values[0] * values[2] + values[1] * values[3]) * 100) / 100).toLocaleString('ja-JP', { maximumFractionDigits: 2 })}` : '—';
    calculator.querySelector('[data-cj-cost-formula]').textContent = valid ? `${values[0]}g × ¥${values[2]} + ${values[1]}g × ¥${values[3]}` : '';
  }
  function initializeCosts() {
    document.querySelectorAll('[data-cj-cost]').forEach(updateCost);
  }
  document.addEventListener('input', event => {
    const calculator = event.target.closest('[data-cj-cost]');
    if (calculator) updateCost(calculator);
  });
  document.addEventListener('click', (event) => {
    const reset = event.target.closest('[data-cj-reset-units]');
    if (reset) {
      const calculator = reset.closest('[data-cj-cost]');
      calculator.querySelectorAll('[data-cj-build-unit], [data-cj-support-unit]').forEach(field => { field.value = field.defaultValue; });
      updateCost(calculator);
    }
    const zoom = event.target.closest('[data-cj-zoom]');
    const dialog = document.querySelector('[data-cj-lightbox]');
    if (zoom && dialog) {
      const source = zoom.querySelector('img');
      if (!source) return;
      const target = dialog.querySelector('img');
      target.src = source.currentSrc || source.src;
      target.alt = source.alt;
      dialog.querySelector('[data-cj-caption]').textContent = source.alt;
      trigger = zoom;
      dialog.showModal();
      return;
    }
    if (event.target.closest('[data-cj-close]') && dialog) dialog.close();
    if (event.target === dialog) {
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    }
    const anchor = event.target.closest('.cj a[href^="#cj-"]');
    if (anchor) {
      const destination = document.getElementById(anchor.getAttribute('href').slice(1));
      if (!destination) return;
      event.preventDefault();
      destination.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      destination.setAttribute('tabindex', '-1');
      destination.focus({ preventScroll: true });
      history.replaceState(null, '', anchor.getAttribute('href'));
    }
  });
  document.addEventListener('close', (event) => {
    if (event.target.matches('[data-cj-lightbox]') && trigger) trigger.focus();
  }, true);
  let orderObserver;
  function observeOrder() {
    if (orderObserver) orderObserver.disconnect();
    const dock = document.querySelector('[data-cj-dock]');
    const order = document.querySelector('.cj-order-copy');
    if (!dock || !order || !('IntersectionObserver' in window)) return;
    orderObserver = new IntersectionObserver(([entry]) => { dock.dataset.hidden = String(entry.isIntersecting); }, { threshold: 0.25 });
    orderObserver.observe(order);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => { observeOrder(); initializeCosts(); }, { once: true });
  else { observeOrder(); initializeCosts(); }
  document.addEventListener('shopify:section:load', observeOrder);
  document.addEventListener('shopify:section:load', initializeCosts);
  document.addEventListener('shopify:section:unload', event => {
    if (orderObserver && event.target.querySelector?.('[data-cj-dock], .cj-order-copy')) orderObserver.disconnect();
  });
})();
